// src/APIs/axios.js
/*import axios from "axios";
import keycloak from "./keycloak";

const api = axios.create({
  baseURL: "http://localhost:8080",
});

api.interceptors.request.use((config) => {
  if (keycloak?.token) {
    config.headers.Authorization = `Bearer ${keycloak.token}`;
  }
  return config;
});

export default api;*/

/*
import axios from "axios";
import keycloak from "./keycloak";

const api = axios.create({
  baseURL: "http://localhost:8080",
});

// ✅ Request interceptor: Always use fresh token
api.interceptors.request.use(
  async (config) => {
    if (keycloak?.authenticated) {
      try {
        // Refresh token if it expires in next 30 seconds
        await keycloak.updateToken(30);
        config.headers.Authorization = `Bearer ${keycloak.token}`;
      } catch (err) {
        console.error("Failed to refresh token:", err);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response interceptor: Retry 401s with fresh token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If 401 and we haven't retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Force token refresh
        await keycloak.updateToken(-1); // -1 forces refresh
        
        // Update the request with new token
        originalRequest.headers.Authorization = `Bearer ${keycloak.token}`;
        
        // Retry the original request
        return api(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed, redirecting to login:", refreshError);
        keycloak.login();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;*/

import axios from "axios";
import keycloak from "./keycloak";
import { showToast } from "./utils/toastManager";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

let isSessionExpired = false;

api.interceptors.request.use(
  async (config) => {
    if (keycloak?.authenticated) {
      try {
        await keycloak.updateToken(30);
        config.headers.Authorization = `Bearer ${keycloak.token}`;
      } catch (err) {
        console.error("Failed to refresh token:", err);
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        await keycloak.updateToken(-1);
        originalRequest.headers.Authorization = `Bearer ${keycloak.token}`;
        return api(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed - session expired:", refreshError);

        const isMeEndpoint = originalRequest.url?.includes("/me");

        if (!isSessionExpired && isMeEndpoint) {
          isSessionExpired = true;

          showToast("Session expired. Please log in again.", "warning");

          // Clear keycloak callback state before logout
          Object.keys(localStorage)
            .filter((k) => k.startsWith("kc-callback-"))
            .forEach((k) => localStorage.removeItem(k));

          try {
            keycloak.logout({
              redirectUri:
                (process.env.REACT_APP_SITE_URL || window.location.origin) +
                "/ProviderSearchPage",
            });
          } catch (logoutError) {
            window.location.href = "/ProviderSearchPage";
          }
        }

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default api;
